export default __webpack_public_path__ + "static/media/Group8882.6a4aab40.svg";